export const sortFieldOptions = [
    { value: 'productiondate', label: 'Productiedatum' },
    { value: 'productnr', label: 'Productnr' },
    { value: 'ordernr', label: 'Ordernr' },
    { value: 'customer', label: 'Klant' },
    { value: 'reference', label: 'Referentie' },
    { value: 'producttype', label: 'Producttype' },
];
export const specialFilters = [
    { value: 'noFilter', label: 'Geen filter' },
    { value: 'pastDueFilter', label: 'In buffertijd' },
    { value: 'recalculatedFilter', label: 'Aangepaste leverdatum' },
    { value: 'finishedFilter', label: 'Toon ook afgewerkte producten' },
    { value: 'eosolFilter', label: 'Groothandel klanten' },
    { value: 'mmFilter', label: 'Particuliere klanten' },
];
export const sortOrderOptions = [
    { value: 'ASC', label: 'Oplopend' },
    { value: 'DESC', label: 'Aflopend' },
];
export const clearedFilters = {
    productnr: null,
    ordernr: null,
    customer: null,
    reference: null,
    producttype: null,
    dimensions: null,
    productionDate: null,
    semifinishedOrdered: null,
    semifinishedDelivered: null,

    sortField: sortFieldOptions[0].value,
    sortOrder: sortOrderOptions[0].value,
    specialFilter: specialFilters[0].value,
};
